import { DoughnutControllerChartOptions, ElementChartOptions } from 'chart.js';
import {
    Chart as ChartJS,
    ArcElement, Tooltip, Legend
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

interface IGrafico {
    dados: any[]
    descricao: string
    descricaoDados: string
    title?: string
    cores?: string[]
}


ChartJS.defaults.elements.arc.borderWidth = 2;
ChartJS.defaults.elements.arc.borderColor = '#8080803b';
ChartJS.defaults.color = 'rgb(55, 65, 81)';



export default function GraficoPizza(props: IGrafico) {

    const config = {
        labels: props.dados.map(el => el[props.descricao]),
        datasets: [{
            label: "QTD",
            data: props.dados.map(el => el[props.descricaoDados]),
            backgroundColor: props.cores?.map(el => el),
            spacing: 3,
        }
        ]
    }

    const options  = {
        response: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right' as const,
                color: '#eeeeee',
                labels: {
                  color: '#eeeeee'
                },
            },
            title: {
                display: true,
                text: props.title,
                color: '#eeeeee'
            },

        }
    }

    return (
        <section style={{ position: 'relative', width: "100%", height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Doughnut
                width={400}
                height={500}
                data={config}
                options={options}
            />
        </section>
    )
}
